import { EVENTS } from '@/scripts/constants/css-classes'
import { ACTION_RESET_MENU_ID, ACTION_UPDATE_MENU_ID } from '@/scripts/store/header/actions'

const resetAndUpdateMenuId = async (el, vnode) => {
  const header = vnode.context
  if (!header.isMobile) {
    const currentMenuId = header.$store.getters['header/currentMenuId']
    const newMenuId = el.dataset.menuId
    if (currentMenuId !== newMenuId) {
      await header.$store.dispatch(`header/${ACTION_RESET_MENU_ID}`)
      header.$store.dispatch(`header/${ACTION_UPDATE_MENU_ID}`, newMenuId)
    }
  }
}

export const MenuMouseEnter = {
  bind(el, _, vnode) {
    el.addEventListener(EVENTS.MOUSE_ENTER, () => resetAndUpdateMenuId(el, vnode))
  },
  unbind(el, _, vnode) {
    el.removeEventListener(EVENTS.MOUSE_ENTER, () => resetAndUpdateMenuId(el, vnode))
  },
}

export const MenuMouseLeave = {
  bind(el, _, vnode) {
    el.addEventListener(EVENTS.MOUSE_LEAVE, () => {
      vnode.context.$store.dispatch(`header/${ACTION_RESET_MENU_ID}`)
    })
  },
  unbind(el, _, vnode) {
    el.removeEventListener(EVENTS.MOUSE_LEAVE, () => {
      vnode.context.$store.dispatch(`header/${ACTION_RESET_MENU_ID}`)
    })
  },
}
